import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import { query, getDocs, collection, where, addDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDcpX82VZmXFasmlUosYOIz5IkvBZFF1e8",
  authDomain: "covidprayaas.firebaseapp.com",
  projectId: "covidprayaas",
  storageBucket: "covidprayaas.appspot.com",
  messagingSenderId: "204445993156",
  appId: "1:204445993156:web:ca2a55975ebcb3032ce191",
  measurementId: "G-G0LYW3P73W",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

// new begin
const googleProvider = new GoogleAuthProvider();
const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const q = query(collection(db, "users"), where("uid", "==", user.uid));
    const docs = await getDocs(q);
    if (docs.docs.length === 0) {
      await addDoc(collection(db, "users"), {
        uid: user.uid,
        name: user.displayName,
        authProvider: "google",
        email: user.email,
      });
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
// new end
const provider = new GoogleAuthProvider();

const logout = () => {
  signOut(auth);
};

export { db, auth, provider, signInWithGoogle, logout };
